import WorkflowExecutionList from './WorkflowExecutionList'
import WorkflowExecutionShow from './WorkflowExecutionShow'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'

export default {
  list: WorkflowExecutionList,
  show: WorkflowExecutionShow,
  icon: PlayCircleOutlineIcon,
}
